import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {LocationType} from "../../../commons/types/location.type";

export class ServiceSelectListCtrl implements IController {

  options: any;
  from: any;
  to: any;
  agentIds: string[];
  group: string;
  selectedId: string[];
  ngPlaceholder: string;
  excludeIds: string[];
  onChange: Function;

  public excludedMap: any;
  public locationTypes: typeof LocationType = LocationType;
  public taskColorByPurpose:any;

  private servicesRef: any;
  private loadLimit: number;
  private infiniteScroll: any;
  private queryString: any;

  constructor(private $delivery, private $infiniteScroll, private $log, private tasksConstants) {
    this.taskColorByPurpose = this.tasksConstants.typesToColor;
  }

  $onInit() {
    if (!this.options) {
      this.servicesRef = this.$delivery();
      this.loadLimit = 20;

      this.servicesRef.$query(this._getQueryPayload());
      this.infiniteScroll = this.$infiniteScroll(this.servicesRef, this.loadLimit, {getFullData: true});
    }
  }

  $onChanges(changes) {
    if (changes.excludeIds) {
      this.excludedMap = {};
      _.forEach(this.excludeIds, (id) => {
        this.excludedMap[id] = true;
      })
    }
  }

  submitQuery(query) {
    this.queryString = query;
    if (!this.options) {
      this._reload();
    }
  }

  private _reload() {
    this.servicesRef.$query(this._getQueryPayload())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.error('Fail to $query', error);
      })
  }

  private _getQueryPayload() {
    return {
      limit: this.loadLimit,
      query: this.queryString,
      from: this.from,
      to: this.to,
      agentIds: this.agentIds,
      group: this.group
    };
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceSelectList', {
    bindings: {
      selectedId: '<',
      options: '<?',
      from: '<?',
      to: '<?',
      agentIds: '<?',
      group: '<?',
      ngPlaceholder: '@?',
      excludeIds: '<?',
      onChange: '&'
    },
    template: require('./service-select-list.html').default,
    controller: ServiceSelectListCtrl
  });
